import { REMOVE_POPUP, TOGGLE_ACTIVE_POPUP } from 'client/actionTypes'
import {
  NEED_SCROLL,
  NeedScrollAction,
  SET_EDITING_ENTITY,
  SET_SETTINGS_EDITING,
  SET_SHOWN_SEARCH_RESULTS,
  SET_USER_COLORS,
  SetEditingEntity,
  SetSettingsEditing,
  SetShownSearchResults,
  SetUserColors,
  SWITCH_ENTITY_INNER_ITEM_ACTIVE_INDEX,
  SwitchEntityInnerItemActiveIndex,
  TOGGLE_INSTANT_UPLOAD,
  TOGGLE_PAYPAL_SETTINGS,
  ToggleInstantUpload,
  TogglePayPalSettings,
} from './managementActionTypes'

export function switchEntityInnerItemActiveIndex(
  entityId: string,
  entityInnerItemActiveIndex: number,
): SwitchEntityInnerItemActiveIndex {
  return {
    type: SWITCH_ENTITY_INNER_ITEM_ACTIVE_INDEX,
    payload: {
      entityId,
      entityInnerItemActiveIndex,
    },
  }
}

export function needScroll(value: boolean): NeedScrollAction {
  return {
    type: NEED_SCROLL,
    payload: value,
  }
}

export function setEditingEntity(entityId: string): SetEditingEntity {
  return {
    type: SET_EDITING_ENTITY,
    payload: entityId,
  }
}

export function setSettingsEditing(
  payload: SetSettingsEditing['payload'],
): SetSettingsEditing {
  return {
    type: SET_SETTINGS_EDITING,
    payload,
  }
}

export function setUserColors(customPallete: string[]): SetUserColors {
  return {
    type: SET_USER_COLORS,
    payload: customPallete,
  }
}

export function disableInstantUpload(): ToggleInstantUpload {
  return {
    type: TOGGLE_INSTANT_UPLOAD,
    payload: false,
  }
}

export function enableInstantUpload(): ToggleInstantUpload {
  return {
    type: TOGGLE_INSTANT_UPLOAD,
    payload: true,
  }
}

export function togglePayPalSettings(value: boolean): TogglePayPalSettings {
  return {
    type: TOGGLE_PAYPAL_SETTINGS,
    payload: value,
  }
}

export const toggleActivePopup = (id: string) => {
  return {
    type: TOGGLE_ACTIVE_POPUP,
    payload: { id },
  }
}

export const removePopup = (id: string) => {
  return {
    type: REMOVE_POPUP,
    payload: { id },
  }
}

export const setShowSearchResults = (list: string[]): SetShownSearchResults => {
  return {
    type: SET_SHOWN_SEARCH_RESULTS,
    payload: list,
  }
}

export type ManagementActions =
  | SwitchEntityInnerItemActiveIndex
  | NeedScrollAction
  | SetEditingEntity
  | SetUserColors
  | ToggleInstantUpload
  | TogglePayPalSettings
  | SetShownSearchResults
